<template>
<!--  Reference: https://www.npmjs.com/package/vue-plaid-link -->
  <div class="plaid-link-wrapper">
    <b-row >
      <b-col class="mt-1">
        <b-row>
          <b-col>
            <slot name="button" v-bind:onClick="handleOnClick">
              <button class="plaid-link-button" @click="handleOnClick"></button>
            </slot>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import DashboardButton from '@/components/utils/buttons/navigation/DashboardButton';

export default {
  name: 'PlaidLink',
  components: {
    DashboardButton,
  },
  props: {
    plaidUrl: {
      type: String,
      default: 'https://cdn.plaid.com/link/v2/stable/link-initialize.js',
    },
    env: {
      type: String,
      default: 'sandbox',
    },
    institution: String,
    selectAccount: Boolean,
    token: String,
    product: {
      type: [String, Array],
      default() {
        return ['transactions'];
      },
    },
    receivedRedirectUri: {
      type: String,
      default: null,
    },
    language: String,
    countryCodes: Array,
    isWebView: Boolean,
    clientName: String,
    publicKey: String,
    webhook: String,
    onLoad: Function,
    onSuccess: Function,
    onExit: Function,
    onEvent: Function,
  },
  created() {
    this.loadScript(this.plaidUrl)
      .then(this.onScriptLoaded)
      .catch(this.onScriptError);
  },
  beforeDestroy() {
    if (window.linkHandler) {
      window.linkHandler.exit();
    }
  },
  methods: {

    onScriptError(error) {
      this.$notify({
        group: 'alert',
        type: 'error',
        text: `There was an issue loading the link-initialize.js script\n${error}`,
      });
    },
    onScriptLoaded() {
      const props = {
        clientName: this.clientName,
        env: this.env,
        key: this.publicKey,
        onExit: this.onExit,
        onEvent: this.onEvent,
        onSuccess: this.onSuccess,
        product: this.product,
        selectAccount: this.selectAccount,
        token: this.token,
        webhook: this.webhook,
      };

      if (this.receivedRedirectUri) {
        props.receivedRedirectUri = this.receivedRedirectUri;
      }

      window.linkHandler = window.Plaid.create(props);
      this.$emit('plaidLoaded');
      this.onLoad();
    },
    handleOnClick() {
      const institution = this.institution || null;
      if (window.linkHandler) {
        window.linkHandler.open(institution);
      }
    },
    loadScript(src) {
      return new Promise(((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }

        const el = document.createElement('script');

        el.type = 'text/javascript';
        el.async = true;
        el.src = src;

        el.addEventListener('load', resolve);
        el.addEventListener('error', reject);
        el.addEventListener('abort', reject);

        document.head.appendChild(el);
      }));
    },
  },
  watch: {
    $props: {
      handler(newVal) {
        if (newVal.token) {
          this.onScriptLoaded();
        }
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/plaid/PlaidLink.vue